module.exports = __webpack_public_path__ + "static/jquery-247cdca36d0494572c0b894dced91623.png";